<template>
  <div class="content">
    <h3>核心指标卡</h3>
    <el-row type="flex" justify="end" align="middle">
      <h4 class="m-r-10">订单时间</h4>
      <el-date-picker
        v-model="date"
        :clearable="false"
        type="daterange"
        @change="changedata"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <div class="m-l-10">
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="getData"
          >搜索</el-button
        >
      </div>
    </el-row>
    <el-row type="flex" :gutter="20" justify="start" class="box-card">
      <el-col :span="8">
        <el-card>
          <img src="@/assets/card4.png" alt="" class="card" />
          <div class="key">总注册用户数</div>
          <span class="value">{{
            userDataCount_data.user_register_num || 0
          }}</span>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <img src="@/assets/card5.png" alt="" class="card" />
          <div class="key">累计订单数：</div>
          <el-row type="flex" align="middle" justify="space-between">
            <span class="value">{{ userDataCount_data.order_num }}</span>
            <el-row type="flex" align="middle" justify="space-between">
              <div class="text1">
                增长率：<span
                  :class="
                    userDataCount_data.order_num_up_rate > 0
                      ? 'text_blue'
                      : 'text_red'
                  "
                  >{{ userDataCount_data.order_num_up_rate }}%</span
                >
              </div>
              <img
                v-if="userDataCount_data.order_num_up_rate > 0"
                src="@/assets/up.png"
                class="img1"
                alt=""
              />
              <img v-else src="@/assets/down.png" class="img1" alt="" />
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <img src="@/assets/card2.png" alt="" class="card" />
          <div class="key">累计销售额：</div>
          <el-row type="flex" align="middle" justify="space-between">
            <span class="value">{{ userDataCount_data.salas }}</span>
            <el-row type="flex" align="middle" justify="space-between">
              <div class="text1">
                增长率:
                <span
                  :class="
                    userDataCount_data.salas_up_rate > 0
                      ? 'text_blue'
                      : 'text_red'
                  "
                  >{{ userDataCount_data.salas_up_rate }}%</span
                >
              </div>
              <img
                v-if="userDataCount_data.salas_up_rate > 0"
                src="@/assets/up.png"
                class="img1"
                alt=""
              />
              <img v-else src="@/assets/down.png" class="img1" alt="" />
            </el-row>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row type="flex" :gutter="20" justify="start">
      <el-col :span="8">
        <el-card>
          <img src="@/assets/card3.png" alt="" class="card" />
          <div class="key">累计分红金额：</div>
          <el-row type="flex" align="middle" justify="space-between">
            <span class="value">{{
              userDataCount_data.total_reward_value
            }}</span>
            <el-row type="flex" align="middle" justify="space-between">
              <div class="text1">
                增长率：<span
                  :class="
                    userDataCount_data.total_reward_value_up_rate > 0
                      ? 'text_blue'
                      : 'text_red'
                  "
                  >{{ userDataCount_data.total_reward_value_up_rate }}%</span
                >
              </div>
              <img
                v-if="userDataCount_data.total_reward_value_up_rate > 0"
                src="@/assets/up.png"
                class="img1"
                alt=""
              />
              <img v-else src="@/assets/down.png" class="img1" alt="" />
            </el-row>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <img src="@/assets/card1.png" alt="" class="card" />
          <div class="key">当前有效VIP 人数/总付费 VIP 人数</div>
          <span class="value"
            >{{ userDataCount_data.user_active_num }}/{{
              userDataCount_data.user_buy_vip_num
            }}</span
          >
        </el-card>
      </el-col>
      <el-col :span="8"
        ><el-card>
          <img src="@/assets/card6.png" alt="" class="card" />
          <div class="key">可提现转GP：</div>
          <span class="value">{{
            userDataCount_data.total_spent_gp || 0
          }}</span>
        </el-card>
      </el-col>
    </el-row>
    <el-row type="flex" justify="start"> </el-row>

    <h3>趋势折线/柱状图</h3>

    <!-- <el-row type="flex" class="tab">
      <div :class="tab1 == 1 && 'actab'" @click="tab1 = 1">今天</div>
      <div :class="tab1 == 2 && 'actab'" @click="tab1 = 2">昨天</div>
      <div :class="tab1 == 3 && 'actab'" @click="tab1 = 3">过去7天</div>
      <div :class="tab1 == 4 && 'actab'" @click="tab1 = 4">过去30天</div>
    </el-row> -->
    <div class="grid">
      <div ref="orderTrends" class="box user"></div>
      <div ref="salesTrend" class="box user"></div>
      <div ref="PVTrend" class="box user"></div>
      <div ref="UVTrend" class="box user"></div>
    </div>
    <h3>分析图</h3>

    <!-- <el-row type="flex" class="tab">
      <div :class="tab2 == 1 && 'actab'" @click="tab2 = 1">今天</div>
      <div :class="tab2 == 2 && 'actab'" @click="tab2 = 2">昨天</div>
      <div :class="tab2 == 3 && 'actab'" @click="tab2 = 3">过去7天</div>
      <div :class="tab2 == 4 && 'actab'" @click="tab2 = 4">过去30天</div>
    </el-row> -->
    <div class="grid">
      <div ref="vipleveltrend" class="box user pa-10"></div>
      <div ref="dividendTrend" class="box user pa-10"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import request from '@/utils/request'
import * as echarts from 'echarts'
export default {
  data() {
    return {
      date: '',
      orderTrends: null,
      salesTrend: null,
      PVTrend: null,
      UVTrend: null,
      vipleveltrend: null,
      dividendTrend: null,
      start_at: '',
      end_at: '',
      count_type: '',
      userDataCount_data: {},
      tab1: 4,
      tab2: 4,
    }
  },
  watch: {
    tab1(nval, oval) {
      switch (nval) {
        case 1:
          this.getTodayRange()
          break
        case 2:
          this.getYesterdayRange()
          break
        case 3:
          this.getLast7DaysRange()
          break
        case 4:
          this.getLast30DaysRange()
          break
      }
      this.reloadorderTrends()
      this.reloadsalesTrend()
      this.reloadUVTrend()
      this.reloadPVTrend()
    },
    tab2(nval, oval) {
      switch (nval) {
        case 1:
          this.getTodayRange()
          break
        case 2:
          this.getYesterdayRange()
          break
        case 3:
          this.getLast7DaysRange()
          break
        case 4:
          this.getLast30DaysRange()
          break
      }
      this.reloadvipleveltrend()
      this.reloaddividendTrend()
    },
  },
  mounted() {
    this.date = [
      moment()
        .subtract(29, 'days')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    ]
    this.$nextTick(() => {
      this.orderTrends = echarts.init(this.$refs['orderTrends'])
      this.salesTrend = echarts.init(this.$refs['salesTrend'])
      this.PVTrend = echarts.init(this.$refs['PVTrend'])
      this.UVTrend = echarts.init(this.$refs['UVTrend'])
      this.vipleveltrend = echarts.init(this.$refs['vipleveltrend'])
      this.dividendTrend = echarts.init(this.$refs['dividendTrend'])
      this.getLast30DaysRange()
      this.userDataCount()
      this.reloadorderTrends()
      this.reloadsalesTrend()
      this.reloadUVTrend()
      this.reloadPVTrend()
      this.reloadvipleveltrend()
      this.reloaddividendTrend()
    })
    let that = this
    window.addEventListener('resize', function () {
      if (that.orderTrends) {
        that.orderTrends.resize()
      }
    })
  },
  methods: {
    getData() {
      this.$nextTick(() => {
        // this.getLast30DaysRange()
        this.userDataCount()
        // this.orderTrends = echarts.init(this.$refs['orderTrends'])
        // this.salesTrend = echarts.init(this.$refs['salesTrend'])
        // this.PVTrend = echarts.init(this.$refs['PVTrend'])
        // this.UVTrend = echarts.init(this.$refs['UVTrend'])
        // this.vipleveltrend = echarts.init(this.$refs['vipleveltrend'])
        // this.dividendTrend = echarts.init(this.$refs['dividendTrend'])

        this.reloadorderTrends()
        this.reloadsalesTrend()
        this.reloadUVTrend()
        this.reloadPVTrend()
        this.reloadvipleveltrend()
        this.reloaddividendTrend()
      })
      let that = this
      window.addEventListener('resize', function () {
        if (that.orderTrends) {
          that.orderTrends.resize()
        }
      })
    },
    getTodayRange() {
      //今天
      this.count_type = 'hour'
      this.start_at = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.end_at = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },

    getYesterdayRange() {
      //昨天
      this.count_type = 'hour'
      this.start_at = moment()
        .subtract(1, 'day')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
      this.end_at = moment()
        .subtract(1, 'day')
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
    },

    getLast7DaysRange() {
      //近7天
      this.count_type = ''
      this.start_at = moment()
        .subtract(6, 'days')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
      this.end_at = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },

    getLast30DaysRange() {
      //近30天
      this.count_type = ''
      this.start_at = moment()
        .subtract(29, 'days')
        .startOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
      this.end_at = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.start_at = val[0] + ' 00:00:00'
        this.end_at = val[1] + ' 23:59:59'
      } else {
        this.start_at = ''
        this.end_at = ''
      }
    },
    userDataCount() {
      // this.getLast30DaysRange()
      request({
        url: '/api/backend/dataCount/userDataCount',
        method: 'get',
        params: {
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.userDataCount_data = res.data
        }
      })
    },
    reloaddividendTrend() {
      request({
        url: '/api/backend/dataCount/revenueChatByVipLevel',
        method: 'get',
        params: {
          count_type: this.count_type,
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var option = {
            title: {
              text: '平均分红金额（按VIP等级）',
              left: 'center',
              bottom: 8,
            },
            tooltip: {
              trigger: 'axis',
            },
            xAxis: {
              type: 'category',
              data: res.data.x,
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                data: res.data.y,
                type: 'bar',
              },
            ],
          }
          this.dividendTrend.setOption(option)
        }
      })
    },
    reloadvipleveltrend() {
      request({
        url: '/api/backend/dataCount/vipLevelChat',
        method: 'get',
        params: {
          count_type: this.count_type,
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var option = {
            title: {
              text: 'VIP 等级分布图',
              left: 'center',
              bottom: 8,
            },
            tooltip: {
              trigger: 'item',
            },
            legend: {
              orient: 'vertical',
              left: 'left',
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                radius: '50%',
                data: res.data.count,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
              },
            ],
          }
          this.vipleveltrend.setOption(option)
        }
      })
    },
    reloadUVTrend() {
      request({
        url: '/api/backend/dataCount/viewLogByUserChat',
        method: 'get',
        params: {
          count_type: this.count_type,
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var option = {
            title: {
              text: 'UV（独立访客数）',
              left: 'center',
              bottom: 8,
            },
            grid: {
              top: '12%',
              left: '5%',
              right: '8%',
              bottom: '10%',
              containLabel: true,
            },
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              top: '4%',
              left: '5%',
              icon: 'rect',
              itemGap: 14,
              itemWidth: 14,
              itemHeight: 3,
              textStyle: {
                fontSize: '0.75rem',
              },
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              axisLine: {},
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                margin: 15,
                padding: [0, 30, 0, 0],
                fontWeight: 'bold',
                fontSize: 14,
                color: 'rgba(0,0,0,0.45)',
              },
              data: res.data.dates,
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                margin: 12,
                fontWeight: 'bold',
                color: 'rgba(0,0,0,0.45)',
                fontSize: 14,
              },
            },
            series: [
              {
                data: res.data.data_report,
                type: 'line',

                symbol: 'none',
                lineStyle: {
                  color: '#5B8FF9',
                  width: 3,
                },
              },
            ],
          }
          this.UVTrend.setOption(option)
        }
      })
    },
    reloadPVTrend() {
      request({
        url: '/api/backend/dataCount/viewLogChat',
        method: 'get',
        params: {
          count_type: this.count_type,
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var option = {
            title: {
              text: 'PV（页面浏览量）',
              left: 'center',
              bottom: 8,
            },
            grid: {
              top: '12%',
              left: '5%',
              right: '8%',
              bottom: '10%',
              containLabel: true,
            },
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              top: '4%',
              left: '5%',
              icon: 'rect',
              itemGap: 14,
              itemWidth: 14,
              itemHeight: 3,
              textStyle: {
                fontSize: '0.75rem',
              },
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              axisLine: {},
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                margin: 15,
                padding: [0, 30, 0, 0],
                fontWeight: 'bold',
                fontSize: 14,
                color: 'rgba(0,0,0,0.45)',
              },
              data: res.data.dates,
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                margin: 12,
                fontWeight: 'bold',
                color: 'rgba(0,0,0,0.45)',
                fontSize: 14,
              },
            },
            series: [
              {
                data: res.data.data_report,
                type: 'line',

                symbol: 'none',
                lineStyle: {
                  color: '#5B8FF9',
                  width: 3,
                },
              },
            ],
          }
          this.PVTrend.setOption(option)
        }
      })
    },
    reloadsalesTrend() {
      request({
        url: '/api/backend/dataCount/salasChat',
        method: 'get',
        params: {
          count_type: this.count_type,
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var option = {
            title: {
              text: '销售额趋势',
              left: 'center',
              bottom: 8,
            },
            grid: {
              top: '12%',
              left: '8%',
              right: '8%',
              bottom: '10%',
              containLabel: true,
            },
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              top: '4%',
              left: '5%',
              icon: 'rect',
              itemGap: 14,
              itemWidth: 14,
              itemHeight: 3,
              textStyle: {
                fontSize: '0.75rem',
              },
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              axisLine: {},
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                margin: 15,
                padding: [0, 30, 0, 0],
                fontWeight: 'bold',
                fontSize: 14,
                color: 'rgba(0,0,0,0.45)',
              },
              data: res.data.dates,
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                margin: 12,
                fontWeight: 'bold',
                color: 'rgba(0,0,0,0.45)',
                fontSize: 14,
              },
            },
            series: [
              {
                data: res.data.data_report,
                type: 'line',

                symbol: 'none',
                lineStyle: {
                  color: '#5B8FF9',
                  width: 3,
                },
              },
            ],
          }
          this.salesTrend.setOption(option)
        }
      })
    },
    reloadorderTrends() {
      request({
        url: '/api/backend/dataCount/orderNumChat',
        method: 'get',
        params: {
          count_type: this.count_type,
          start_at: this.start_at,
          end_at: this.end_at,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          var option = {
            title: {
              text: '订单趋势',
              left: 'center',
              bottom: 8,
            },
            grid: {
              top: '12%',
              left: '5%',
              right: '8%',
              bottom: '10%',
              containLabel: true,
            },
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              top: '4%',
              left: '5%',
              icon: 'rect',
              itemGap: 14,
              itemWidth: 14,
              itemHeight: 3,
              textStyle: {
                fontSize: '0.75rem',
              },
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              axisLine: {},
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                margin: 15,
                padding: [0, 30, 0, 0],
                fontWeight: 'bold',
                fontSize: 14,
                color: 'rgba(0,0,0,0.45)',
              },
              data: res.data.dates,
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                margin: 12,
                fontWeight: 'bold',
                color: 'rgba(0,0,0,0.45)',
                fontSize: 14,
              },
            },
            series: [
              {
                data: res.data.data_report,
                type: 'line',

                symbol: 'none',
                lineStyle: {
                  color: '#5B8FF9',
                  width: 3,
                },
              },
            ],
          }
          this.orderTrends.setOption(option)
        }
      })
    },
  },
}
</script>

<style>
.content {
  height: 100%;
  padding: 20px;
}
.key {
  font-weight: 600;
  font-size: 1rem;
  color: #000000;
  line-height: 1.38rem;
  margin-bottom: 1rem;
}
.value {
  color: #546dfe;
  line-height: 1.75rem;
  font-weight: bold;
  font-size: 1.25rem;
}
.img1 {
  width: 15px;
}
.text1 {
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.38rem;
}
.box-card {
  margin-bottom: 20px;
}

.tab > div {
  position: relative;
  margin: 0 15px 0 0;
  cursor: pointer;
}

.tab .actab::after {
  position: absolute;
  content: '';
  left: 0;
  right: 0;
  width: 28px;
  height: 3px;
  background: #b4926e;
  bottom: -4px;
  margin: auto;
}
.actab {
  color: #b4926e;
}
.box {
  background: #ffffff;
  box-shadow: 0px 0px 19px 0px rgba(185, 185, 185, 0.17);
  border-radius: 16px;
}

.user {
  height: 595px;
}

.grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.pa-10 {
  padding: 10px;
}

.text_blue {
  color: #34a752;
}
.text_red {
  color: #e54639;
}
.el-card {
  border-radius: 0.75rem;
}
.card {
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 14px;
}
</style>
